import React, { createContext, useState, useContext, useCallback } from 'react';

const OverlayContext = createContext();

export const OverlayProvider = ({ children }) => {
    const [isOverlayOpen, setIsOverlayOpen] = useState(false);
    const [isOverlayVisible, setOverlayIsVisible] = useState(false);
    const [overlayContent, setOverlayContent] = useState(null);
    const [overlayTitle, setOverlayTitle] = useState(null);
    const [overlaySubtitle, setOverlaySubtitle] = useState(null);
    const [overlayImage, setOverlayImage] = useState(null);
    const [onCloseCallback, setOnCloseCallback] = useState(null);

    const setOverlay = (content, title = null, subtitle = null, image = null, onClose = null) => {
        console.log("setOverlay", content, title, subtitle, image);
        if (React.isValidElement(content)) {
            setOverlayContent(content);
        }
        setOverlayImage(image);
        setOverlayTitle(title);
        setOverlaySubtitle(subtitle);
        setOnCloseCallback(() => onClose);
        setIsOverlayOpen(true);
    };

    const openOverlay = (isOpen) => {
        setIsOverlayOpen(isOpen);
    };

    const closeOverlay = useCallback(() => {
        if (onCloseCallback) {
            onCloseCallback();
        }
        
        const event = new CustomEvent('overlay-closed');
        document.dispatchEvent(event);
        
        setOverlayContent(null);
        setOverlayTitle(null);
        setOverlaySubtitle(null);
        setOverlayImage(null);
        setOnCloseCallback(null);
        setIsOverlayOpen(false);
        setOverlayIsVisible(false);
    }, [onCloseCallback]);

    return (
        <OverlayContext.Provider value={{ 
            isOverlayOpen,  
            openOverlay, 
            closeOverlay, 
            isOverlayVisible, 
            setOverlayIsVisible, 
            overlayContent, 
            overlayTitle, 
            setOverlayTitle, 
            overlaySubtitle, 
            setOverlaySubtitle, 
            overlayImage, 
            setOverlayImage, 
            setOverlay 
        }}>
            {children}
        </OverlayContext.Provider>
    );
}

export const useOverlay = () => {
    const context = useContext(OverlayContext);
    if (!context) {
        throw new Error('useOverlay must be used within an OverlayProvider');
    }
    return context;
}
